/** Executive Minimal section — quiet vertical rhythm, no boxed containers. */
export default function Section({ title, hint, action, children, testId }) {
  return (
    <section className="st-section" data-testid={testId}>
      {(title || action) && (
        <header className="st-section-header">
          <div>
            {title && <h2 className="st-section-title">{title}</h2>}
            {hint && <div className="st-section-hint">{hint}</div>}
          </div>
          {action}
        </header>
      )}
      {children}
    </section>
  );
}
